/**
 * Trello 596 APP MISC "27 OCT 2": one-time purchases are switched off
 * (backend config services.purchase.single_purchase_enabled, default off).
 * Since 1 Oct 2026 every Xendit payment attempt costs a fee, paid or not, and
 * a one-time checkout opened a fresh Xendit session on every tap.
 *
 * The backend is the enforcement (checkout answers 422
 * single_purchase_disabled, listings leave single-purchase packages out,
 * product detail sends checkout_available=false). This file only holds the
 * shared copy and the one check the checkout page uses to swap its one-time
 * payment buttons for a calm notice pointing to the subscription plans.
 */
import { isSinglePurchasePackage } from "./xtLaneFlag";

export const SUBSCRIPTION_PLANS_HREF = "/premium";

const COPY = {
  en: {
    message: "One-time purchase is not available right now. Please choose a subscription plan.",
    linkLabel: "See subscription plans",
  },
  id: {
    message: "Pembelian sekali bayar sedang tidak tersedia. Silakan pilih paket langganan.",
    linkLabel: "Lihat paket langganan",
  },
};

// A plan list that is empty for any other reason (no single_purchase:false
// in the payload) must not blame the one-time switch.
const NO_PLANS_COPY = {
  en: {
    message: "No plans are available on this page.",
    linkLabel: COPY.en.linkLabel,
  },
  id: {
    message: "Paket di halaman ini belum tersedia.",
    linkLabel: COPY.id.linkLabel,
  },
};

const isIndonesian = (language) => String(language || "").toLowerCase() === "id";

export const getSinglePurchaseUnavailableCopy = (language) => (
  isIndonesian(language) ? COPY.id : COPY.en
);

export const getNoPlansAvailableCopy = (language) => (
  isIndonesian(language) ? NO_PLANS_COPY.id : NO_PLANS_COPY.en
);

// Landing payloads say outright when one-time packages are switched off.
export const isSinglePurchaseSwitchedOff = (enabledPackageTypes) => !!(
  enabledPackageTypes && enabledPackageTypes.single_purchase === false
);

// A free-access voucher (vouchers/apply answers type "free") makes the
// package free, so the backend keeps that checkout open and so do we.
export const isFreeAccessVoucher = (voucher) => !!(
  voucher && String(voucher.type || "").toLowerCase() === "free"
);

export const isSinglePurchaseCheckoutUnavailable = (content, activeVoucher) => !!(
  content
  && isSinglePurchasePackage(content)
  && content.checkout_available === false
  && !isFreeAccessVoucher(activeVoucher)
);

// Landing payloads: true when the page has nothing left to sell, e.g. a
// landing that only sold one-time packages while those are switched off
// (enabled_package_types {single_purchase:false, subscription:false}) or an
// empty plan list. Landings that still have subscriptions render as before.
export const hasNoSellablePackages = (planGroups) => {
  const groups = Array.isArray(planGroups) ? planGroups : [];
  return !groups.some((group) => group && Array.isArray(group.packages) && group.packages.length > 0);
};
